// src/auth/hooks/useRecaptcha.ts
import { useEffect, useRef, useState } from 'react';
import { RecaptchaVerifier } from 'firebase/auth';

export function useRecaptcha(auth: any, containerId: string) {
  const recaptchaRef = useRef<RecaptchaVerifier | null>(null);
  const [ready, setReady] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    const attemptCreate = () => {
      if (cancelled) return;

      const containerElem = document.getElementById(containerId);
      if (!containerElem) {
        setTimeout(attemptCreate, 500);
        return;
      }

      const verifier = new RecaptchaVerifier(
        containerId,
        {
          size: 'invisible',
          callback: () => {
            // We rely on Firebase's verifyPhoneNumber(...) to trigger this callback.
          },
        },
        auth
      );

      verifier
        .render()
        .then(() => {
          if (cancelled) {
            verifier.clear();
            return;
          }
          recaptchaRef.current = verifier;
          setReady(true);
        })
        .catch((err) => {
          console.error('reCAPTCHA render failed:', err);
        });
    };

    setTimeout(attemptCreate, 0);

    return () => {
      cancelled = true;
      if (recaptchaRef.current) {
        recaptchaRef.current.clear();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, containerId]);

  return ready ? recaptchaRef.current! : null;
}
